<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-post-3-oilprice-box">
  <!-- Artboard: xs -->
  <div
    id="g-post-3-oilprice-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.43478260869565;"
  >
    <div
      id="g-post-3-oilprice-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-3-oilprice-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:7.6078%;margin-top:-12.5px;right:27.1372%;width:98px;"
    >
      <p class="g-pstyle0">U.S. - Israel</p>
      <p class="g-pstyle0">attacks on Iran</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:11.5209%;margin-top:-7.5px;left:0%;width:77px;"
    >
      <p class="g-pstyle1">$80/barrel</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:20.8687%;margin-top:-19px;left:76.1883%;width:97px;"
    >
      <p class="g-pstyle2">Brent crude oil</p>
      <p class="g-pstyle2">(per barrel)</p>
      <p class="g-pstyle3">$79.38</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:25.4339%;margin-top:-7.5px;left:0%;width:34px;"
    >
      <p class="g-pstyle1">75</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:40.8687%;margin-top:-19px;left:76.1883%;width:90px;"
    >
      <p class="g-pstyle4">U.S. crude oil</p>
      <p class="g-pstyle4">(per barrel)</p>
      <p class="g-pstyle5">$72.41</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:39.7818%;margin-top:-7.5px;left:0%;width:35px;"
    >
      <p class="g-pstyle1">70</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:54.1296%;margin-top:-7.5px;left:0%;width:35px;"
    >
      <p class="g-pstyle1">65</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:68.0426%;margin-top:-7.5px;left:0%;width:36px;"
    >
      <p class="g-pstyle1">60</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:82.3905%;margin-top:-7.5px;left:0%;width:35px;"
    >
      <p class="g-pstyle1">55</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:93.6948%;margin-top:-14.5px;left:8.3338%;margin-left:-21px;width:42px;"
    >
      <p class="g-pstyle6">4</p>
      <p class="g-pstyle6">Jan.</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:90.6513%;margin-top:-7.5px;left:16.3724%;margin-left:-15px;width:30px;"
    >
      <p class="g-pstyle6">11</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:90.6513%;margin-top:-7.5px;left:24.466%;margin-left:-16.5px;width:33px;"
    >
      <p class="g-pstyle6">18</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:90.6513%;margin-top:-7.5px;left:32.4987%;margin-left:-17.5px;width:35px;"
    >
      <p class="g-pstyle6">25</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:93.6948%;margin-top:-14.5px;left:40.5849%;margin-left:-22px;width:44px;"
    >
      <p class="g-pstyle6">1</p>
      <p class="g-pstyle6">Feb.</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:90.6513%;margin-top:-7.5px;left:48.6256%;margin-left:-14.5px;width:29px;"
    >
      <p class="g-pstyle6">8</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:90.6513%;margin-top:-7.5px;left:56.685%;margin-left:-16.5px;width:33px;"
    >
      <p class="g-pstyle6">15</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:90.6513%;margin-top:-7.5px;left:64.7269%;margin-left:-17.5px;width:35px;"
    >
      <p class="g-pstyle6">22</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:93.6948%;margin-top:-14.5px;left:72.6731%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle6">1</p>
      <p class="g-pstyle6">March</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-post-3-oilprice-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.41666666666667;"
  >
    <div
      id="g-post-3-oilprice-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-3-oilprice-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:5.4392%;margin-top:-14.6px;right:19.4849%;width:111px;"
    >
      <p class="g-pstyle0">U.S. - Israel</p>
      <p class="g-pstyle0">attacks on Iran</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:7.2447%;margin-top:-9.1px;left:-0.0002%;width:87px;"
    >
      <p class="g-pstyle1">$80/barrel</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:15.9947%;margin-top:-22.6px;left:82.6314%;width:109px;"
    >
      <p class="g-pstyle2">Brent crude oil</p>
      <p class="g-pstyle2">(per barrel)</p>
      <p class="g-pstyle3">$79.38</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:22.5225%;margin-top:-9.1px;left:-0.0002%;width:36px;"
    >
      <p class="g-pstyle1">75</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:37.3836%;margin-top:-22.6px;left:82.6314%;width:101px;"
    >
      <p class="g-pstyle4">U.S. crude oil</p>
      <p class="g-pstyle4">(per barrel)</p>
      <p class="g-pstyle5">$72.41</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:38.0781%;margin-top:-9.1px;left:-0.0002%;width:37px;"
    >
      <p class="g-pstyle1">70</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:53.3558%;margin-top:-9.1px;left:-0.0002%;width:38px;"
    >
      <p class="g-pstyle1">65</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:68.6336%;margin-top:-9.1px;left:-0.0002%;width:38px;"
    >
      <p class="g-pstyle1">60</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:84.1892%;margin-top:-9.1px;left:-0.0002%;width:37px;"
    >
      <p class="g-pstyle1">55</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.3281%;margin-top:-16.6px;left:9.2032%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle6">4</p>
      <p class="g-pstyle6">January</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.1058%;margin-top:-8.6px;left:18.0472%;margin-left:-16px;width:32px;"
    >
      <p class="g-pstyle6">11</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.1058%;margin-top:-8.6px;left:26.8668%;margin-left:-17.5px;width:35px;"
    >
      <p class="g-pstyle6">18</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.1058%;margin-top:-8.6px;left:35.6566%;margin-left:-18.5px;width:37px;"
    >
      <p class="g-pstyle6">25</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.3281%;margin-top:-16.6px;left:44.4809%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle6">1</p>
      <p class="g-pstyle6">February</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.1058%;margin-top:-8.6px;left:53.3479%;margin-left:-15px;width:30px;"
    >
      <p class="g-pstyle6">8</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.1058%;margin-top:-8.6px;left:62.2231%;margin-left:-17.5px;width:35px;"
    >
      <p class="g-pstyle6">15</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.1058%;margin-top:-8.6px;left:71.0196%;margin-left:-18.5px;width:37px;"
    >
      <p class="g-pstyle6">22</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.3281%;margin-top:-16.6px;left:79.875%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle6">1</p>
      <p class="g-pstyle6">March</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-post-3-oilprice-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.83333333333333;"
  >
    <div
      id="g-post-3-oilprice-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-3-oilprice-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:5.9947%;margin-top:-14.6px;right:15.5167%;width:111px;"
    >
      <p class="g-pstyle0">U.S. - Israel</p>
      <p class="g-pstyle0">attacks on Iran</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:7.8003%;margin-top:-9.1px;left:0%;width:87px;"
    >
      <p class="g-pstyle1">$80/barrel</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.5503%;margin-top:-22.6px;left:86.305%;width:109px;"
    >
      <p class="g-pstyle2">Brent crude oil</p>
      <p class="g-pstyle2">(per barrel)</p>
      <p class="g-pstyle3">$79.38</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:23.0781%;margin-top:-9.1px;left:0%;width:36px;"
    >
      <p class="g-pstyle1">75</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:37.9392%;margin-top:-22.6px;left:86.305%;width:101px;"
    >
      <p class="g-pstyle4">U.S. crude oil</p>
      <p class="g-pstyle4">(per barrel)</p>
      <p class="g-pstyle5">$72.41</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:38.6336%;margin-top:-9.1px;left:0%;width:37px;"
    >
      <p class="g-pstyle1">70</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:53.9114%;margin-top:-9.1px;left:0%;width:38px;"
    >
      <p class="g-pstyle1">65</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:69.1892%;margin-top:-9.1px;left:0%;width:38px;"
    >
      <p class="g-pstyle1">60</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:84.7447%;margin-top:-9.1px;left:0%;width:37px;"
    >
      <p class="g-pstyle1">55</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.8836%;margin-top:-16.6px;left:9.6267%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle6">4</p>
      <p class="g-pstyle6">January</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.6614%;margin-top:-8.6px;left:18.8833%;margin-left:-16px;width:32px;"
    >
      <p class="g-pstyle6">11</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.6614%;margin-top:-8.6px;left:28.1206%;margin-left:-17.5px;width:35px;"
    >
      <p class="g-pstyle6">18</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.6614%;margin-top:-8.6px;left:37.3352%;margin-left:-18.5px;width:37px;"
    >
      <p class="g-pstyle6">25</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.8836%;margin-top:-16.6px;left:46.5763%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle6">1</p>
      <p class="g-pstyle6">February</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.6614%;margin-top:-8.6px;left:55.8505%;margin-left:-15px;width:30px;"
    >
      <p class="g-pstyle6">8</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.6614%;margin-top:-8.6px;left:65.1311%;margin-left:-17.5px;width:35px;"
    >
      <p class="g-pstyle6">15</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:92.6614%;margin-top:-8.6px;left:74.3509%;margin-left:-18.5px;width:37px;"
    >
      <p class="g-pstyle6">22</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.8836%;margin-top:-16.6px;left:83.6161%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle6">1</p>
      <p class="g-pstyle6">March</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-post-3-oilprice-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.89795918367347;"
  >
    <div
      id="g-post-3-oilprice-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-3-oilprice-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:4.4212%;margin-top:-16.7px;right:13.4074%;width:123px;"
    >
      <p class="g-pstyle0">U.S. - Israel</p>
      <p class="g-pstyle0">attacks on Iran</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:6.6661%;margin-top:-8.7px;left:0%;width:96px;"
    >
      <p class="g-pstyle1">$80/barrel</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:15.0334%;margin-top:-25.7px;left:88.5487%;width:122px;"
    >
      <p class="g-pstyle2">Brent crude oil</p>
      <p class="g-pstyle2">(per barrel)</p>
      <p class="g-pstyle3">$79.38</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:22.9926%;margin-top:-8.7px;left:0%;width:38px;"
    >
      <p class="g-pstyle1">75</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:37.6865%;margin-top:-25.7px;left:88.5487%;width:113px;"
    >
      <p class="g-pstyle4">U.S. crude oil</p>
      <p class="g-pstyle4">(per barrel)</p>
      <p class="g-pstyle5">$72.41</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:39.5233%;margin-top:-8.7px;left:0%;width:39px;"
    >
      <p class="g-pstyle1">70</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:55.8498%;margin-top:-8.7px;left:0%;width:40px;"
    >
      <p class="g-pstyle1">65</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.1763%;margin-top:-8.7px;left:0%;width:40px;"
    >
      <p class="g-pstyle1">60</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:88.5029%;margin-top:-8.7px;left:0%;width:40px;"
    >
      <p class="g-pstyle1">55</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.6661%;margin-top:-16.7px;left:9.8411%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle6">4</p>
      <p class="g-pstyle6">January</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0335%;margin-top:-8.7px;left:19.3443%;margin-left:-16.5px;width:33px;"
    >
      <p class="g-pstyle6">11</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0335%;margin-top:-8.7px;left:28.8549%;margin-left:-18.5px;width:37px;"
    >
      <p class="g-pstyle6">18</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0335%;margin-top:-8.7px;left:38.301%;margin-left:-19.5px;width:39px;"
    >
      <p class="g-pstyle6">25</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.6661%;margin-top:-16.7px;left:47.8224%;margin-left:-41px;width:82px;"
    >
      <p class="g-pstyle6">1</p>
      <p class="g-pstyle6">February</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0335%;margin-top:-8.7px;left:57.2937%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle6">8</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0335%;margin-top:-8.7px;left:66.7702%;margin-left:-18px;width:36px;"
    >
      <p class="g-pstyle6">15</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0335%;margin-top:-8.7px;left:76.2745%;margin-left:-19.5px;width:39px;"
    >
      <p class="g-pstyle6">22</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.6661%;margin-top:-16.7px;left:85.7692%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle6">1</p>
      <p class="g-pstyle6">March</p>
    </div>
  </div>

  <!-- Artboard: xl -->
  <div
    id="g-post-3-oilprice-xl"
    class="g-artboard"
    style="display: none;aspect-ratio: 2.44897959183673;"
  >
    <div
      id="g-post-3-oilprice-xl-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-3-oilprice-xl.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:4.4212%;margin-top:-16.7px;right:10.6081%;width:123px;"
    >
      <p class="g-pstyle0">U.S. - Israel</p>
      <p class="g-pstyle0">attacks on Iran</p>
    </div>
    <div
      id="g-ai4-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:6.6661%;margin-top:-8.7px;left:0%;width:96px;"
    >
      <p class="g-pstyle1">$80/barrel</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:15.0335%;margin-top:-25.7px;left:91.0678%;width:122px;"
    >
      <p class="g-pstyle2">Brent crude oil</p>
      <p class="g-pstyle2">(per barrel)</p>
      <p class="g-pstyle3">$79.38</p>
    </div>
    <div
      id="g-ai4-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:22.9927%;margin-top:-8.7px;left:0%;width:38px;"
    >
      <p class="g-pstyle1">75</p>
    </div>
    <div
      id="g-ai4-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:37.6865%;margin-top:-25.7px;left:91.0678%;width:113px;"
    >
      <p class="g-pstyle4">U.S. crude oil</p>
      <p class="g-pstyle4">(per barrel)</p>
      <p class="g-pstyle5">$72.41</p>
    </div>
    <div
      id="g-ai4-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:39.5232%;margin-top:-8.7px;left:0%;width:39px;"
    >
      <p class="g-pstyle1">70</p>
    </div>
    <div
      id="g-ai4-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:55.8498%;margin-top:-8.7px;left:0%;width:40px;"
    >
      <p class="g-pstyle1">65</p>
    </div>
    <div
      id="g-ai4-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.1763%;margin-top:-8.7px;left:0%;width:40px;"
    >
      <p class="g-pstyle1">60</p>
    </div>
    <div
      id="g-ai4-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:88.5028%;margin-top:-8.7px;left:0%;width:40px;"
    >
      <p class="g-pstyle1">55</p>
    </div>
    <div
      id="g-ai4-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.6661%;margin-top:-16.7px;left:10.161%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle6">4</p>
      <p class="g-pstyle6">January</p>
    </div>
    <div
      id="g-ai4-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0334%;margin-top:-8.7px;left:19.9666%;margin-left:-16.5px;width:33px;"
    >
      <p class="g-pstyle6">11</p>
    </div>
    <div
      id="g-ai4-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0334%;margin-top:-8.7px;left:29.7781%;margin-left:-18.5px;width:37px;"
    >
      <p class="g-pstyle6">18</p>
    </div>
    <div
      id="g-ai4-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0334%;margin-top:-8.7px;left:39.5395%;margin-left:-19.5px;width:39px;"
    >
      <p class="g-pstyle6">25</p>
    </div>
    <div
      id="g-ai4-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.6661%;margin-top:-16.7px;left:49.3593%;margin-left:-41px;width:82px;"
    >
      <p class="g-pstyle6">1</p>
      <p class="g-pstyle6">February</p>
    </div>
    <div
      id="g-ai4-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0334%;margin-top:-8.7px;left:59.1402%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle6">8</p>
    </div>
    <div
      id="g-ai4-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0334%;margin-top:-8.7px;left:68.9253%;margin-left:-18px;width:36px;"
    >
      <p class="g-pstyle6">15</p>
    </div>
    <div
      id="g-ai4-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0334%;margin-top:-8.7px;left:78.7318%;margin-left:-19.5px;width:39px;"
    >
      <p class="g-pstyle6">22</p>
    </div>
    <div
      id="g-ai4-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.6661%;margin-top:-16.7px;left:88.5309%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle6">1</p>
      <p class="g-pstyle6">March</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2026-03-02 14:48 -->

<!-- Generated by ai2html v0.101.0 - 2026-03-02 14:48 -->
<!-- ai file: post-3-oilprice.ai -->
<style lang="scss">
  #g-post-3-oilprice-box,
  #g-post-3-oilprice-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-3-oilprice-box p {
    margin: 0;
  }
  #g-post-3-oilprice-box .g-aiAbs {
    position: absolute;
  }
  #g-post-3-oilprice-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-3-oilprice-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-3-oilprice-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-3-oilprice-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-3-oilprice-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post-3-oilprice-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-post-3-oilprice-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post-3-oilprice-xl {
        display: block !important;
      }
    }
  }
  #g-post-3-oilprice-xs {
    position: relative;
    overflow: hidden;
  }
  #g-post-3-oilprice-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 500;
    line-height: 12px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-3-oilprice-xs .g-pstyle0 {
    height: 12px;
    text-align: right;
  }
  #g-post-3-oilprice-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    color: rgb(166, 166, 166);
  }
  #g-post-3-oilprice-xs .g-pstyle2 {
    height: 12px;
    color: rgb(222, 45, 38);
  }
  #g-post-3-oilprice-xs .g-pstyle3 {
    font-weight: 900;
    line-height: 13px;
    height: 13px;
    color: rgb(222, 45, 38);
  }
  #g-post-3-oilprice-xs .g-pstyle4 {
    height: 12px;
    color: rgb(43, 126, 185);
  }
  #g-post-3-oilprice-xs .g-pstyle5 {
    font-weight: 900;
    line-height: 13px;
    height: 13px;
    color: rgb(43, 126, 185);
  }
  #g-post-3-oilprice-xs .g-pstyle6 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    text-align: center;
    color: rgb(123, 123, 123);
  }
  #g-post-3-oilprice-sm {
    position: relative;
    overflow: hidden;
  }
  #g-post-3-oilprice-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(123, 123, 123);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-3-oilprice-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-3-oilprice-sm .g-pstyle1 {
    line-height: 17px;
    height: 17px;
    color: rgb(166, 166, 166);
  }
  #g-post-3-oilprice-sm .g-pstyle2 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    color: rgb(222, 45, 38);
  }
  #g-post-3-oilprice-sm .g-pstyle3 {
    font-weight: 900;
    height: 16px;
    color: rgb(222, 45, 38);
  }
  #g-post-3-oilprice-sm .g-pstyle4 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    color: rgb(43, 126, 185);
  }
  #g-post-3-oilprice-sm .g-pstyle5 {
    font-weight: 900;
    height: 16px;
    color: rgb(43, 126, 185);
  }
  #g-post-3-oilprice-sm .g-pstyle6 {
    height: 16px;
    text-align: center;
  }
  #g-post-3-oilprice-md {
    position: relative;
    overflow: hidden;
  }
  #g-post-3-oilprice-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(123, 123, 123);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-3-oilprice-md .g-pstyle0 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-3-oilprice-md .g-pstyle1 {
    line-height: 17px;
    height: 17px;
    color: rgb(166, 166, 166);
  }
  #g-post-3-oilprice-md .g-pstyle2 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    color: rgb(222, 45, 38);
  }
  #g-post-3-oilprice-md .g-pstyle3 {
    font-weight: 900;
    height: 16px;
    color: rgb(222, 45, 38);
  }
  #g-post-3-oilprice-md .g-pstyle4 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    color: rgb(43, 126, 185);
  }
  #g-post-3-oilprice-md .g-pstyle5 {
    font-weight: 900;
    height: 16px;
    color: rgb(43, 126, 185);
  }
  #g-post-3-oilprice-md .g-pstyle6 {
    height: 16px;
    text-align: center;
  }
  #g-post-3-oilprice-lg {
    position: relative;
    overflow: hidden;
  }
  #g-post-3-oilprice-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(123, 123, 123);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-3-oilprice-lg .g-pstyle0 {
    font-weight: 500;
    height: 16px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-3-oilprice-lg .g-pstyle1 {
    height: 16px;
    color: rgb(166, 166, 166);
  }
  #g-post-3-oilprice-lg .g-pstyle2 {
    font-weight: 500;
    height: 16px;
    color: rgb(222, 45, 38);
  }
  #g-post-3-oilprice-lg .g-pstyle3 {
    font-weight: 900;
    line-height: 18px;
    height: 18px;
    color: rgb(222, 45, 38);
  }
  #g-post-3-oilprice-lg .g-pstyle4 {
    font-weight: 500;
    height: 16px;
    color: rgb(43, 126, 185);
  }
  #g-post-3-oilprice-lg .g-pstyle5 {
    font-weight: 900;
    line-height: 18px;
    height: 18px;
    color: rgb(43, 126, 185);
  }
  #g-post-3-oilprice-lg .g-pstyle6 {
    height: 16px;
    text-align: center;
  }
  #g-post-3-oilprice-xl {
    position: relative;
    overflow: hidden;
  }
  #g-post-3-oilprice-xl p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(123, 123, 123);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-3-oilprice-xl .g-pstyle0 {
    font-weight: 500;
    height: 16px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post-3-oilprice-xl .g-pstyle1 {
    height: 16px;
    color: rgb(166, 166, 166);
  }
  #g-post-3-oilprice-xl .g-pstyle2 {
    font-weight: 500;
    height: 16px;
    color: rgb(222, 45, 38);
  }
  #g-post-3-oilprice-xl .g-pstyle3 {
    font-weight: 900;
    line-height: 18px;
    height: 18px;
    color: rgb(222, 45, 38);
  }
  #g-post-3-oilprice-xl .g-pstyle4 {
    font-weight: 500;
    height: 16px;
    color: rgb(43, 126, 185);
  }
  #g-post-3-oilprice-xl .g-pstyle5 {
    font-weight: 900;
    line-height: 18px;
    height: 18px;
    color: rgb(43, 126, 185);
  }
  #g-post-3-oilprice-xl .g-pstyle6 {
    height: 16px;
    text-align: center;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
